import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionDataService } from './../services/session-data.service';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private sessionDataService: SessionDataService,
    private UTS: UtilitiesService
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      this.UTS.getENV().toLocaleLowerCase() == 'mobile' &&
      this.UTS.getJSessionID()
    ) {
      let CSRF = request.headers != null ? request.headers.get("X-CSRF-TOKEN") : null;
      const accessToken = this.UTS.getAccessToken()?this.UTS.getAccessToken():"";
      let action =request.headers != null ? request.headers.get("action"): null
      const header = {
        Channel: this.UTS.getENV().toLocaleUpperCase(),
        transactionId: Date.now().toString(),
        'access-token': accessToken,
        'JSESSIONID': this.UTS.getJSessionID(),
        authorization: 'Bearer ' + accessToken,
        "content-type": "application/json;charset=UTF-8",
        'Accept-Encoding': "UTF-8",
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "If-Modified-Since": "0",
        "MagentoCartId":this.UTS.getMagentoCartId(),
        "wso2AccessToken": this.UTS.getWSO2AccessToken(),
        "individualLoginAccountNo": this.UTS.getIndividualLoginAccountNo(),
        "Locale": localStorage.getItem('language')=='ar'?'ar_AE':'en_AE',
        "action": action,
        BigIpServer: (this.UTS.getBigIpServer() && this.UTS.getBigIpServer() != "") ?
          this.UTS.getBigIpServer() : null,
          subChannel: this.UTS.getMobileOperatingSystem()
            ? this.UTS.getENV().toLocaleLowerCase() == 'mobile' &&
              this.UTS.getMobileOperatingSystem() == 'Android'
              ? 'MOBILEAPP_ANDRIOD'
              : this.UTS.getENV().toLocaleLowerCase() == 'mobile' &&
                this.UTS.getMobileOperatingSystem() == 'iOS'
              ? 'MOBILEAPP_IOS'
              : null
            : null,
      };
      if (!header['MagentoCartId']) {
        delete header['MagentoCartId'];
      }
      if (!header['wso2AccessToken']) {
        delete header['wso2AccessToken'];
      }
      if(!header['access-token']){
        delete header['access-token'];
      }
      if (!header[action]) {
         delete header["action"];
      }
      if (!header['BigIpServer']) {
        delete header['BigIpServer'];
      }
      if (!header['subChannel']) {
        delete header['subChannel'];
      }
      if (!header['individualLoginAccountNo']) {
        delete header['individualLoginAccountNo'];
      }

      request = request.clone({
        headers: new HttpHeaders(header),
        withCredentials: true,
      });
    } else {
      let CSRF = request.headers != null ? request.headers.get("X-CSRF-TOKEN") : null;
      let action =request.headers != null ? request.headers.get("action"): null
      let header = {
        Channel: this.UTS.getENV().toLocaleUpperCase(),
        transactionId: Date.now().toString(),
        "content-type": "application/json;charset=UTF-8",
        'Accept-Encoding': "UTF-8",
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "If-Modified-Since": "0",
        "Locale": localStorage.getItem('language')=='ar'?'ar_AE':'en_AE',
      };
      if (this.UTS.getMagentoCartId() && this.UTS.getMagentoCartId()!=""){
        header['MagentoCartId'] = this.UTS.getMagentoCartId();
      }
      if (CSRF && CSRF != '') {
        header["X-CSRF-TOKEN"] = CSRF;
      }
      if (action && action != '') {
        header["action"] = action;
      }
      header['transactionId'] = Date.now().toString();

      const isWebView = sessionStorage.getItem('isWebView') == 'true' ? true : false;
      const isEjariAppFlow = sessionStorage.getItem('ejariApp') == 'true' ? true : false;
      const isTeleSalesFlow = (sessionStorage.getItem('elife_teleSales') == 'true') || (sessionStorage.getItem('postpaid_teleSales') == 'true') ? true : false;
      if (isWebView) {
        header['Channel'] = 'MobileWebView';
      } else if (isEjariAppFlow) {
        header['Channel'] = 'Ejari';
      } else if (isTeleSalesFlow) {
        header['Channel'] = 'CS-Telesales';
      } else {
        header['Channel'] = 'Portal';
      }
      const subChannel = sessionStorage.getItem('subChannel');
      if (subChannel) {
        header['subChannel'] = subChannel;
      }
      if (isTeleSalesFlow){
         header['subChannel'] = 'IndirectSale';
      }
      request = request.clone({
        headers: new HttpHeaders(header),
        withCredentials: true,
      });
    }


    // console.log(request)
    // // Check if it's a POST request and modify the payload if needed
    // if (request.method === 'POST' && request.body && request.url && request.url.includes('/b2c/eshop/activateAccounts')) {
    //   const modifiedBody = this.convertArabicStringsToUTF8(request.body);
    //   // Create a new request with the modified payload
    //   const modifiedReq = request.clone({
    //     body: modifiedBody
    //   });

    //   return next.handle(modifiedReq);
    // }
    // else {
      return next.handle(request);
    // }
  }


  // Recursive function to convert Arabic strings to UTF-8 strings
  private convertArabicStringsToUTF8(obj: any): any {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Check if the value is an object and continue recursively
        if (typeof value === 'object' && value !== null) {
          obj[key] = this.convertArabicStringsToUTF8(value);
        } else if (typeof value === 'string' && this.containsArabicCharacters(value)) {
          // If the value is a string containing Arabic characters, convert to UTF-8
          obj[key] = this.convertToUnicodeEscapeSequence(value).replace(/\\\\/g,'\\');
        }
      }
    }
    return obj;
  }

  convertToUnicodeEscapeSequence(str) {
    let unicodeEscape = '';

    for (let i = 0; i < str.length; i++) {
      // Get the Unicode code point of each character in the string
      const codePoint = str.charCodeAt(i);

      // Convert the code point to a Unicode escape sequence
      unicodeEscape += '\\u' + codePoint.toString(16).toUpperCase().padStart(4, '0');
    }
    return unicodeEscape;
  }

  // Function to check if a string contains Arabic characters
  private containsArabicCharacters(str: string): boolean {
    const arabicPattern = /[\u0600-\u06FF]/;
    return arabicPattern.test(str);
  }
}
